import Vue from 'vue';
import BootstrapVueTreeview from 'bootstrap-vue-treeview';

Vue.use(BootstrapVueTreeview);
